import { Col, Form, Row } from "react-bootstrap";
import { Label } from "../../Common/Label/Label";
import { useTranslation } from "react-i18next";
import { BasicDetail_INVESTOR_NEW } from "../../../assets/interface/primeSharkWebsite_interface";
import HelperService from "../../../Services/HelperService";
import PhoneInput1 from "../../PhoneInput/PhoneInput1";
import {
  dropdownApiNewcall,
  isMobileNumberValid,
  getCountryListAPiCall,
} from "../../../Services/CommonFunction";
import RequiredLabel from "../../Common/RequiredLabel/RequiredLabel";
import Select1 from "react-select";
import { DROPDOWNTYPES } from "../../../assets/constants/constants";
import { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import ErrorComponent from "../../Common/ErrorComponent";
import Select from "react-dropdown-select";
import CurrencySelect from "../../Common/CurrencyDropDown/CurrencyDropdwon";
import { MdVerifiedUser } from "react-icons/md";
import { useLocation } from "react-router-dom";
import GoogleAddressSearch from "../../GoogleAddressSearch/GoogleAddressSearch";
import "./select.scss";
import PasswordInput from "../../Common/PasswordInput";
import { isWarning } from "../Helper";
import WebService from "../../../Services/WebService";
import VerifyMobileOTP from "../../Profile/VerifyMobile";
import ChangeMobileNumberModal from "../../Profile/ChangeMobileNumber";
import ChangeEmailModal from "../../Profile/ChangeEmail";
import VerifyEmailOTP from "../../Profile/VerifyEmailOTP";

interface PropsData {
  basicDetails: BasicDetail_INVESTOR_NEW;
  handleChange: (name: string, value: any) => void;
  errorFlag: boolean;
  handlePhoneNumberChange: any;
  handleArrayValueChange: (value: any[], key: string) => void;
  fields_to_improve: any;
  emailVerifyAt: any;
  from?: string;
  skipButtonClicked: boolean;
}
const types = [
  DROPDOWNTYPES.OPERATIONAL_REGION,
  DROPDOWNTYPES.DESIGNATION_ROLE,
  DROPDOWNTYPES.INVESTMENT_EXPERIENCE,
  DROPDOWNTYPES.BUSINESS_INDUSTRY,
];
const BasicDetails_INDIVIDUAL_INVESTOR = ({
  basicDetails,
  handleChange,
  errorFlag,
  handlePhoneNumberChange,
  fields_to_improve,
  emailVerifyAt,
  from,
  handleArrayValueChange,
  skipButtonClicked,
}: PropsData) => {
  const { t } = useTranslation();
  const [dropdownData, setDropdownData] = useState<Record<string, any[]>>({});
  let location = useLocation();
  let status = location?.state?.disable;
  const [menuOpen, setMenuOpen] = useState(false);
  const controlRef = useRef<HTMLDivElement | null>(null);
  const controlRef1 = useRef<HTMLDivElement | null>(null);
  const [menuOpen1, setMenuOpen1] = useState(false);
  const [showOTPVerify, setShowOTPVerify] = useState(false);
  const [showChangeMobileModal, setShowChangeMobileModal] = useState(false);
  const [dial_code, setdial_Code] = useState("");
  const [mobile_number, setMoible_number] = useState("");
  const [country_code, setCountryCode] = useState("");
  const [showEmail, setShowEmail] = useState(false);
  const [email, setEmail] = useState("");
  const [showEmailOTPVerify, setShowEmailOTPVerify] = useState(false);
  const [countryOptions, setCountryOptions] = useState<{ label: string; value: string }[]>([]);

  useEffect(() => {
    getCountryListAPiCall("")
      .then((data: any) => {
        if (Array.isArray(data)) {
          const formatted = data.map((item: any) => ({
            label: item?.title || item?.name || "",
            value: item?.title || item?.name || "",
          }));
          setCountryOptions(formatted);
        }
      })
      .catch(() => { });
  }, []);

  const hasAccessToken = localStorage.getItem("access_token");
  useEffect(() => {
    if (!menuOpen) return;

    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];

        if (!entry.isIntersecting) {
          setMenuOpen(false);
        }
      },
      {
        root: null, // viewport
        threshold: 0, // even 1px visibility counts
      },
    );

    if (controlRef.current) {
      observer.observe(controlRef.current);
    }

    return () => observer.disconnect();
  }, [menuOpen]);
  useEffect(() => {
    if (!menuOpen1) return;

    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];

        if (!entry.isIntersecting) {
          setMenuOpen(false);
        }
      },
      {
        root: null, // viewport
        threshold: 0, // even 1px visibility counts
      },
    );

    if (controlRef.current) {
      observer.observe(controlRef.current);
    }

    return () => observer.disconnect();
  }, [menuOpen1]);
  useEffect(() => {
    loadDropdowns();
  }, []);
  async function loadDropdowns() {
    try {
      const res = await dropdownApiNewcall("investor", types);
      const formattedData: Record<string, any[]> = {};

      types.forEach((type) => {
        const items = res[type];

        if (Array.isArray(items)) {
          if (type === "business_industry") {
            const grouped = items.reduce((acc: Record<string, any[]>, item: any) => {
              const groupName = item.group || "Other";
              if (!acc[groupName]) acc[groupName] = [];
              acc[groupName].push({
                label: item.title,
                value: item?.is_other === 1 ? "Other" : item.title,
              });
              return acc;
            }, {});

            formattedData[type] = Object.entries(grouped).map(
              ([group, options]) => ({
                label: group,
                options,
              }),
            );
          } else {
            formattedData[type] = items.map((item: any) => ({
              label: item.title,
              value: item.title,
            }));
          }
        }
      });

      setDropdownData(formattedData);
    } catch (error) { }
  }
  const handleSendOTP = () => {
    WebService.addLoader("verify-otp");
    const isProfileMode = from === "REVIEW" || from === "FROM_PROFILE_ANALYSIS";
    const apiCall = isProfileMode ? WebService.postAPI : WebService.beforeLoginPostAPI;
    const action = isProfileMode ? "verify-mobile/send-otp" : "otp/resend";

    return apiCall({
      action: action,
      body: {
        login_field: "MOBILE_NUMBER",
        mobile_number: HelperService.removeDialCode(
          basicDetails?.mobile_number,
          basicDetails?.dial_code,
        ),
        email: basicDetails?.email,
        dial_code: basicDetails?.dial_code,
        country_code: basicDetails?.country_code,
      },
      isShowError: false,
    })
      .then((res: any) => {
        if (res?.status) {
          toast.success(res.message);
          setdial_Code(basicDetails?.dial_code || "");
          setMoible_number(basicDetails?.mobile_number || "");
          setCountryCode(basicDetails?.country_code || "");
          setShowOTPVerify(true);
        } else {
          toast.error(res.message);
        }
      })
      .catch((error: any) => {
        toast.error(error?.response?.data?.message);
      })
      .finally(() => {
        WebService.removeLoader("verify-otp");
      });
  };

  return (
    <>
      <Row>
        <Col lg={6} className="mb-2">
          <RequiredLabel isRequired={true}>First Name</RequiredLabel>
          <Form.Control
            type="text"
            disabled={from === "REVIEW" || status}
            placeholder="Enter your first name"
            name="first_name"
            value={basicDetails?.first_name || ""}
            onChange={(e) => handleChange(e?.target?.name, e?.target?.value)}
            className={
              (!basicDetails?.first_name && skipButtonClicked) ||
                isWarning(fields_to_improve, "first_name")
                ? "warning-field"
                : ""
            }
          />
          {!skipButtonClicked && errorFlag && !basicDetails?.first_name && (
            <Label title="Please enter first name" modeError={true} />
          )}
        </Col>

        <Col lg={6} className="mb-2">
          <RequiredLabel isRequired={true}>Last Name</RequiredLabel>

          <Form.Control
            type="text"
            disabled={from === "REVIEW" || status}
            placeholder="Enter your last name"
            name="last_name"
            value={basicDetails?.last_name || ""}
            onChange={(e) => handleChange(e?.target?.name, e?.target?.value)}
            className={
              (!basicDetails?.last_name && skipButtonClicked) ||
                isWarning(fields_to_improve, "last_name")
                ? "warning-field"
                : ""
            }
          />
          {!skipButtonClicked && errorFlag && !basicDetails?.last_name && (
            <Label title="Please enter last name" modeError={true} />
          )}
        </Col>

        <Col lg={6} className="mb-2">
          <div className="d-flex justify-content-between">
            <RequiredLabel isRequired={false}>
              {t("Register.mobile_number")}
            </RequiredLabel>
            {basicDetails?.mobile_number &&
              basicDetails?.mobile_verified_at && (
                <div className="d-flex gap-1 justify-content-end">
                  <MdVerifiedUser color="green" className="" />
                  <span className="font-12 text-success">
                    {t("entrepenure_investment_basic_details.verified")}
                  </span>
                </div>
              )}{" "}
            {basicDetails?.mobile_number?.replace(
              `+${basicDetails?.dial_code}`,
              "",
            ) !== "" &&
              !basicDetails?.mobile_verified_at && (
                <span
                  id="verify-otp"
                  className="verify-otp-btn"
                  onClick={handleSendOTP}
                >
                  Verify
                </span>
              )}
          </div>
          <PhoneInput1
            disabled={
              from === "REVIEW" || status || from === "FROM_PROFILE_ANALYSIS"
            }
            placeHolder="Enter your mobile number"
            value={basicDetails?.mobile_number}
            dial_code={basicDetails?.dial_code}
            errorFlag={errorFlag}
            handlePhoneNumberChange={(value, countryData) => {
              handlePhoneNumberChange(value, countryData);
            }}
            className={
              isWarning(fields_to_improve, "mobile_number")
                ? "warning-field"
                : ""
            }
          />

          {!skipButtonClicked &&
            errorFlag &&
            basicDetails.mobile_number &&
            !isMobileNumberValid(
              basicDetails?.mobile_number || "",
              basicDetails?.dial_code || "",
            ) && (
              <Label
                title="Please enter valid mobile number"
                modeError={true}
              />
            )}
          {!basicDetails?.mobile_number &&
            (from === "REVIEW" || from === "FROM_PROFILE_ANALYSIS") ? (
            <a
              href="#"
              className="mt-0 font-12 font-bold"
              style={{
                color: "#235299",
                cursor: "pointer",
                textDecoration: "underline",
              }}
              onClick={(e) => {
                e.preventDefault();
                setShowChangeMobileModal(true);
              }}
            >
              Add Mobile Number
            </a>
          ) : (from === "REVIEW" || from === "FROM_PROFILE_ANALYSIS") &&
            basicDetails ? (
            <div className="d-flex justify-content-between ">
              <div
                className="mt-0 font-14 font-bold cursor-pointer"
                style={{ color: "#66C15E" }}
                onClick={() => {
                  setShowChangeMobileModal(true);
                }}
              >
                Change Mobile Number
              </div>
            </div>
          ) : null}
        </Col>

        <Col lg={6} className="mb-2">
          <div className="d-flex justify-content-between">
            <RequiredLabel isRequired={true}>
              {t("Register.email")}
            </RequiredLabel>
            {emailVerifyAt && (
              <div className="d-flex gap-1 justify-content-end">
                <MdVerifiedUser color="green" className="" />
                <span className="font-12 text-success">
                  {t("entrepenure_investment_basic_details.verified")}
                </span>
              </div>
            )}{" "}
          </div>
          <Form.Control
            type="text"
            placeholder="Enter your official email address"
            name="email"
            disabled={
              from === "REVIEW" || status || from === "FROM_PROFILE_ANALYSIS"
            }
            value={basicDetails?.email || ""}
            onChange={(e) => handleChange(e?.target?.name, e?.target?.value)}
            className={
              isWarning(fields_to_improve, "email") ? "warning-field" : ""
            }
          />
          {(from === "REVIEW" || from === "FROM_PROFILE_ANALYSIS") && (
            <div
              className="mt-1 font-14 font-bold cursor-pointer text-end"
              style={{ color: "#66C15E" }}
              onClick={() => setShowEmail(true)}
            >
              Change Email
            </div>
          )}
          {((errorFlag && !basicDetails?.email) ||
            (errorFlag &&
              basicDetails?.email &&
              !HelperService.isValidEmail(basicDetails?.email || ""))) && (
              <Label title={t("Register.invalid_email")} modeError={true} />
            )}
        </Col>
        <Col lg={12}>
          {!hasAccessToken && (
            <>
              <PasswordInput
                label="Password"
                name="password"
                value={basicDetails?.password || ""}
                onChange={(e) => handleChange(e.target.name, e.target.value)}
                required
                strongValidate
              />
              {!basicDetails?.password && errorFlag && (
                <Label title="Please enter password" modeError={true} />
              )}
            </>
          )}
        </Col>
        <Col>
          <RequiredLabel isRequired={true}>Preferred Currency</RequiredLabel>
          <CurrencySelect
            className={
              (!basicDetails?.preferred_currency && skipButtonClicked) ||
                isWarning(fields_to_improve, "preferred_currency")
                ? "warning-field"
                : ""
            }
            onChange={(value: any) => {
              if (value?.value) {
                handleArrayValueChange(value, "preferred_currency");
              }
            }}
          />
          <ErrorComponent
            title="Please select preffered currency"
            flag={errorFlag && !skipButtonClicked}
            isArray={false}
            data={basicDetails?.preferred_currency}
          />
        </Col>

        <Col lg={6} className="mb-2">
          <RequiredLabel isRequired={false}>Business Email</RequiredLabel>
          <Form.Control
            type="text"
            placeholder="Enter business email"
            name="business_email"
            value={basicDetails?.business_email || ""}
            onChange={(e) => handleChange(e?.target?.name, e?.target?.value)}
            className={
              isWarning(fields_to_improve, "business_email")
                ? "warning-field"
                : ""
            }
          />
          {/* {((errorFlag && !basicDetails?.business_email) ||
          (errorFlag &&
            basicDetails?.business_email &&
            !HelperService.isValidEmail(basicDetails?.business_email))) && (
          <Label title={t("Register.invalid_email")} modeError={true} />
        )} */}
        </Col>

        <Col lg={12} className="mb-2">
          <GoogleAddressSearch
            label={<RequiredLabel isRequired={true}>Address</RequiredLabel>}
            mode="address"
            className={
              (!basicDetails?.address && skipButtonClicked) ||
                isWarning(fields_to_improve, "address")
                ? "warning-field"
                : ""
            }
            value={basicDetails?.address || ""}
            onSelect={(
              address: string,
              place: google.maps.places.PlaceResult,
              geo: { lat: number | null; lng: number | null },
            ) => {
              handleChange("address", address);
              // handleChange("la", geo?.lat ? geo?.lat?.toString() : "")
              // handleChange("la", geo?.lng ? geo?.lng?.toString() : "")
              let city = "";
              let state = "";
              let country = "";
              let pincode = "";

              if (place.address_components) {
                for (let component of place.address_components) {
                  if (component.types.includes("locality")) {
                    city = component.long_name;
                  }
                  if (component.types.includes("administrative_area_level_1")) {
                    state = component.long_name;
                  }
                  if (component.types.includes("country")) {
                    country = component.long_name;
                  }
                  if (component.types.includes("postal_code")) {
                    pincode = component.long_name;
                  }
                }
              }

              handleChange("postal_code", pincode);
              handleChange("city", city);
              handleChange("state", state);
              handleChange("country", country);
            }}
          />

          {!skipButtonClicked && errorFlag && !basicDetails?.address && (
            <Label title="Please enter address" modeError={true} />
          )}
        </Col>

        <Col lg={6} className="mb-2">
          <RequiredLabel isRequired={true}>City</RequiredLabel>
          <Form.Control
            type="text"
            placeholder=" Enter city name State/Province"
            name="city"
            value={basicDetails?.city || ""}
            onChange={(e) => handleChange(e?.target?.name, e?.target?.value)}
            className={
              (!basicDetails?.city && skipButtonClicked) ||
                isWarning(fields_to_improve, "city")
                ? "warning-field"
                : ""
            }
          />
          {/* {errorFlag && !basicDetails?.city && (
          <Label title="Please enter city" modeError={true} />
        )} */}
        </Col>

        <Col lg={6} className="mb-2">
          <RequiredLabel isRequired={true}>State/Province</RequiredLabel>
          <Form.Control
            type="text"
            placeholder="Enter state"
            name="state"
            value={basicDetails?.state || ""}
            onChange={(e) => handleChange(e?.target?.name, e?.target?.value)}
            className={
              (!basicDetails?.state && skipButtonClicked) ||
                isWarning(fields_to_improve, "state")
                ? "warning-field"
                : ""
            }
          />
          {/* {errorFlag && !basicDetails?.state && (
          <Label title="Please enter state" modeError={true} />
        )} */}
        </Col>

        <Col lg={6} className="mb-2">
          <RequiredLabel isRequired={false}>Postal/ZIP Code</RequiredLabel>

          <Form.Control
            type="text"
            placeholder="Enter state or province Postal/ZIP Code"
            name="postal_code"
            value={basicDetails?.postal_code || ""}
            onChange={(e) => handleChange(e?.target?.name, e?.target?.value)}
            onKeyDown={(e) => {
              if (
                !/^\d$/.test(e.key) &&
                e.key.length === 1 &&
                !e.ctrlKey &&
                !e.metaKey
              ) {
                e.preventDefault();
              }
            }}
            className={
              isWarning(fields_to_improve, "postal_code") ? "warning-field" : ""
            }
          />
          {/* {errorFlag && !basicDetails?.postal_code && (
          <Label title="Please enter postal code" modeError={true} />
        )} */}
        </Col>

        <Col lg={6} className="mb-2">
          <RequiredLabel isRequired={true}>
            Country of Registration
          </RequiredLabel>

          <Select1
            options={countryOptions}
            placeholder="Select country"
            value={
              basicDetails?.country
                ? { label: basicDetails.country, value: basicDetails.country }
                : null
            }
            onChange={(selected: any) =>
              handleChange("country", selected?.value || "")
            }
            className={
              (!basicDetails?.country && skipButtonClicked) ||
                isWarning(fields_to_improve, "country")
                ? "warning-field"
                : ""
            }
          />
          {!skipButtonClicked && errorFlag && !basicDetails?.country && (
            <Label title="Please enter country" modeError={true} />
          )}
        </Col>

        <Col lg={12} className="mb-2">
          <RequiredLabel isRequired={false}>LinkedIn Profile</RequiredLabel>

          <Form.Control
            type="text"
            placeholder="Enter LinkedIn profile URL"
            name="linkdin_profile"
            value={basicDetails?.linkdin_profile || ""}
            onChange={(e) => handleChange(e?.target?.name, e?.target?.value)}
            className={
              isWarning(fields_to_improve, "linkdin_profile")
                ? "warning-field"
                : ""
            }
          />
          {basicDetails?.linkdin_profile &&
            !HelperService?.checkLinkedinUrl(basicDetails?.linkdin_profile || "") &&
            errorFlag && (
              <Label
                modeError={true}
                title="Please enter valid founder linkedin profile"
              />
            )}
        </Col>

        <Col lg={6} className="mb-2">
          <RequiredLabel isRequired={false}>WhatsApp Number</RequiredLabel>

          <Form.Control
            type="text"
            maxLength={16}
            placeholder="Enter WhatsApp number with country code"
            name="whatsapp_number"
            value={basicDetails?.whatsapp_number || ""}
            onChange={(e) => {
              const val = e.target.value.replace(/[^0-9+-\s]/g, "");
              handleChange("whatsapp_number", val);
            }}
            className={
              isWarning(fields_to_improve, "whatsapp_number")
                ? "warning-field"
                : ""
            }
          />
        </Col>

        <Col lg={6} className="mb-2">
          <RequiredLabel isRequired={false}>
            Investment Experience (years)
          </RequiredLabel>
          <Select
            dropdownHeight="200px"
            dropdownPosition="top"
            placeholder="Select investment experience"
            className={
              isWarning(fields_to_improve, "investment_experience")
                ? "warning-field"
                : ""
            }
            options={dropdownData[DROPDOWNTYPES.INVESTMENT_EXPERIENCE] || []}
            onChange={(values: any) => {
              if (values?.length > 0) {
                handleArrayValueChange(values[0], "investment_experience");
              }
            }}
            labelField="label"
            valueField="value"
            name="investment_experience"
            style={{
              whiteSpace: "normal", // ✅ allow text wrapping
              wordBreak: "break-word",
              alignItems: "center",
            }}
            values={
              basicDetails?.investment_experience
                ? [
                  {
                    value: basicDetails?.investment_experience,
                    label: basicDetails?.investment_experience,
                  },
                ]
                : []
            }
          />
        </Col>

        <Col lg={12} className="mb-2">
          <RequiredLabel isRequired={true}>
            Preferred Investment Sector (max 3)
          </RequiredLabel>
          <div ref={controlRef1}>
            <Select1
              classNamePrefix="react-select"
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 999999 }),
              }}
              placeholder="Select preferred investment sectors"
              isMulti
              closeMenuOnSelect={false}
              maxMenuHeight={280}
              menuPortalTarget={document.body}
              menuIsOpen={menuOpen1}
              onMenuOpen={() => setMenuOpen1(true)}
              onMenuClose={() => setMenuOpen1(false)}
              closeMenuOnScroll={false}
              menuPosition="fixed"
              options={dropdownData[DROPDOWNTYPES.BUSINESS_INDUSTRY] || []}
              onChange={(values: any) => {
                if (values?.length > 3) {
                  toast.warn("You can select a maximum of 3 options.");
                  return false;
                } else handleArrayValueChange(values, "area_of_investment");
              }}
              className={
                (basicDetails?.area_of_investment?.length === 0 &&
                  skipButtonClicked) ||
                  isWarning(fields_to_improve, "area_of_investment")
                  ? "warning-field "
                  : ""
              }
              name="area_of_investment"
              value={
                basicDetails?.area_of_investment?.length > 0
                  ? basicDetails?.area_of_investment.map((item: any) => ({
                    value: item?.title,
                    label: item?.title,
                  }))
                  : []
              }
            />
          </div>
          <ErrorComponent
            title="Please select area of investment"
            flag={errorFlag && !skipButtonClicked}
            isArray={true}
            data={basicDetails?.area_of_investment}
          />
        </Col>
        {basicDetails?.area_of_investment?.some(
          (item: any) => item?.title === "Other",
        ) && (
            <div className="w-100 mt-2">
              <RequiredLabel isRequired={true}>
                Other Investment Sector
              </RequiredLabel>

              <Form.Control
                type="text"
                className={
                  isWarning(fields_to_improve, "area_of_investment")
                    ? "warning-field"
                    : ""
                }
                placeholder="Enter other investment sector"
                onChange={(e) => {
                  const value = e.target.value;

                  const updated = basicDetails?.area_of_investment?.map(
                    (item: any) =>
                      item.title === "Other" ? { ...item, other: value } : item,
                  );

                  handleChange("area_of_investment", updated);
                }}
                value={
                  basicDetails?.area_of_investment?.find(
                    (item: any) => item?.title === "Other",
                  )?.other || ""
                }
              />

              {errorFlag &&
                basicDetails?.area_of_investment?.some(
                  (item: any) =>
                    item?.title === "Other" &&
                    (!item?.other || item?.other.trim() === ""),
                ) && (
                  <Label
                    title="Please enter other investment sector"
                    modeError={true}
                  />
                )}
            </div>
          )}

        <Col lg={12} className="mb-2">
          <RequiredLabel isRequired={false}>
            Designation / Role(If Applicable)
          </RequiredLabel>

          <Select
            dropdownHeight="200px"
            dropdownPosition="top"
            className={
              isWarning(fields_to_improve, "designation")
                ? "warning-field "
                : ""
            }
            options={dropdownData[DROPDOWNTYPES.DESIGNATION_ROLE] || []}
            onChange={(values: any) => {
              if (values?.length > 0) {
                handleArrayValueChange(values[0], "designation_role");
              }
            }}
            labelField="label"
            valueField="value"
            name="designation_role"
            placeholder="Select your designation or role"
            values={
              basicDetails?.designation_role
                ? [
                  {
                    value: basicDetails?.designation_role,
                    label: basicDetails?.designation_role,
                  },
                ]
                : []
            }
          />
          {/* <ErrorComponent
          title="Please select designation role"
          flag={errorFlag}
          isArray={true}
          data={basicDetails?.designation_role}
        /> */}
        </Col>
        <Col lg={12} className="form-wrapper mb-2">
          <RequiredLabel isRequired={true}>
            Operational/Focus Regions (max 3)
          </RequiredLabel>
          <div ref={controlRef}>
            <Select1
              placeholder="Select operational or investment focus regions"
              classNamePrefix="react-select"
              className={
                (basicDetails?.operational_region?.length === 0 &&
                  skipButtonClicked) ||
                  isWarning(fields_to_improve, "operational_region")
                  ? "warning-field "
                  : ""
              }
              menuPosition="fixed"
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 999999 }),
              }}
              menuPortalTarget={document.body}
              menuIsOpen={menuOpen}
              onMenuOpen={() => setMenuOpen(true)}
              onMenuClose={() => setMenuOpen(false)}
              closeMenuOnScroll={false}
              options={dropdownData[DROPDOWNTYPES.OPERATIONAL_REGION] || []}
              isMulti
              menuPlacement="bottom"
              onChange={(values: any) => {
                if (values?.length > 3) {
                  toast.warn("You can select a maximum of 3 options.");
                  return false;
                } else handleArrayValueChange(values, "operational_region");
              }}
              name="operational_region"
              value={
                basicDetails?.operational_region?.length > 0
                  ? basicDetails?.operational_region.map((item: any) => ({
                    value: item?.title,
                    label: item?.title,
                  }))
                  : []
              }
            />
          </div>

          <ErrorComponent
            title="Please select operational region"
            flag={errorFlag && !skipButtonClicked}
            isArray={true}
            data={basicDetails?.operational_region}
          />
        </Col>
      </Row>
      {showOTPVerify && (
        <VerifyMobileOTP
          contactInfo={{
            dial_code: dial_code,
            mobile_number: mobile_number,
            country_code: country_code,
          }}
          handleHide={(flag) => {
            if (flag) {
              handleChange("mobile_number", mobile_number);
              handleChange("mobile_verified_at", new Date());
            }
            setShowOTPVerify(false);
          }}
          show={showOTPVerify}
        />
      )}
      {showChangeMobileModal && (
        <ChangeMobileNumberModal
          onHide={() => {
            setShowChangeMobileModal(false);
          }}
          mode={basicDetails?.mobile_number ? "ADD" : "UPDATE"}
          onSave={(dialCode, mobile, country_code1) => {
            const cleanMobile = HelperService.removeDialCode(mobile, dialCode);
            setdial_Code(dialCode);
            setMoible_number(cleanMobile);
            setCountryCode(country_code1);
            handleChange("dial_code", dialCode);
            handleChange("country_code", country_code1);
            handleChange("mobile_number", cleanMobile);
            handleChange("mobile_verified_at", new Date());
          }}
          defaultDialCode={basicDetails?.dial_code || ""}
          show={showChangeMobileModal}
        />
      )}

      {showEmail && (
        <ChangeEmailModal
          onHide={() => {
            setShowEmail(false);
          }}
          onSave={(email) => {
            setEmail(email);
            setShowEmail(false);
            setShowEmailOTPVerify(true);
          }}
          show={showEmail}
        />
      )}
      {showEmailOTPVerify && (
        <VerifyEmailOTP
          email={email}
          handleHide={(flag) => {
            if (flag) {
              handleChange("email", email);
              handleChange("email_verified_at", new Date());
            }
            setShowEmailOTPVerify(false);
          }}
          show={showEmailOTPVerify}
        />
      )}
    </>
  );
};

export default BasicDetails_INDIVIDUAL_INVESTOR;
